import { BodyUtility } from '../../Components/AxUtility/BodyUtility';
import { AxInit, ModuleName } from '../../Lib/AxSystem/AxInit';
import { AxLoad } from '../../Lib/AxSystem/AxLoad';

@ModuleName("PopUpShoppingCart")
export class PopUpShoppingCart implements AxInit {
    constructor(protected _bodyUtility: BodyUtility = new BodyUtility()) { }

    AxInit() {
        $(document).on('click', '.ax-nav-item-sc', (e) => {
            e.preventDefault();
            $('.pop-up-cart').removeClass('collapsed');
            $('.pop-up-cart--filler').show();
            setTimeout(() => $('.pop-up-cart--filler').removeClass('collapsed'), 10);
            this.loadPopUpShoppingCart();
        });

        $(document).on('click', '.pop-up-cart--closeBtn, .pop-up-cart--filler', (e) => {
            e.preventDefault();
            $('.pop-up-cart, .pop-up-cart--filler').addClass('collapsed');
            setTimeout(() => $('.pop-up-cart--filler').hide(), 300);
            setTimeout(() => this.unloadPopUpShoppingCart(), 350);
        });

        $(document).on('click', '.pop-up-cart--deleteItemBtn', (e) => {
            e.preventDefault();
            const cartEntryID = $(e.target).attr('data-position-id');
            this.removeCartEntry(cartEntryID);
        });

        $(document).on('click', '.pop-up-cart--giftCardRemove', (e) => {
            e.preventDefault();
            const cartEntryID = $(e.target).attr('data-position-id');
            this.removeCartEntry(cartEntryID);
        });

        $(document).on('click', '#btnApplyPromoCode', (e) => {
            e.preventDefault();
            this.applyPromoCode();
        });

        $(document).on('click',
            '.pop-up-cart--entryPromoCode',
            (e) => {
                e.preventDefault();
                let promocode = $(e.target).attr('data');
                this.unloadPopUpShoppingCart();
                AxessViewer.loadPartialView('/ShoppingCart/RemovePromoCode',
                    { code: promocode },
                    () => {
                        this.loadPopUpShoppingCart();
                    },
                    {
                        reload: false,
                    });
            });

        $(() => {
            if (localStorage.getItem('reloadFlag') === 'true') {
                const popUpCartFiller$ = $('.pop-up-cart--filler');
                const popUpShoppingCart = new PopUpShoppingCart();
                localStorage.removeItem('reloadFlag');
                $('.pop-up-cart').removeClass('collapsed');
                popUpCartFiller$.css('display', 'block');
                setTimeout(() => popUpCartFiller$.css('opacity', 0.7), 10);

                popUpShoppingCart.loadPopUpShoppingCart();
            }
        });
    }

    private loadPopUpShoppingCart() {
        const url = '/ShoppingCart/GetPopUpShoppingCart';
        const data = {};
        $('html').css('top', 0).scrollTop(0);

        AxessViewer.loadPartialView(url, data, (res) => {
            $('#popUpShoppingCart').html(res);
            this._bodyUtility.DisableScroll();


            AxLoad.LoadModule("ShoppingCartReservationTimer");
        }, {
            dataType: 'html',
        })
    }

    private unloadPopUpShoppingCart() {
        this._bodyUtility.EnableScroll();
        const spinner$ = $('<div>', { class: 'ax-loading-spinner pop-up-cart--loader' });
        $('#popUpShoppingCart').html(spinner$.html());
    }

    private removeCartEntry(cartEntryID: string) {
        this.unloadPopUpShoppingCart();

        AxessViewer.loadPartialView('/ShoppingCart/RemoveCartPosition',
            { targetPositionId: cartEntryID },
            () => this.loadPopUpShoppingCart(),
            { reload: false },
        );
    }

    private applyPromoCode() {
        $('[data-promocode="result"]').remove();

        const giftCardSerialNr: string | number | string[] = $('#PromoCodePop').val();

        AxessViewer.loadPartialView('/ShoppingCart/CheckPromoCodes', {
            promoCodes: [giftCardSerialNr],
        }, (result: ICheckPromoCodeResult) => {
            if (result.success && result.discountFound) {
                if (result?.isPromocodeApplied == false) {
                    this.applyGiftCardEMoney(giftCardSerialNr, result);
                } else {
                    localStorage.setItem('reloadFlag', 'true');
                    location.reload();
                }
            } else if (result?.isPromocodeApplied === false) {
                this.applyGiftCardEMoney(giftCardSerialNr, result);
            }
        });
    }


    private getGiftCardSerialNr() {
        const promocode: string | number | string[] = $('#PromoCodePop').val();
        if (!promocode) {
            return;
        }
        return promocode;
    }

    private applyGiftCardEMoney(giftCard: string | number | string[], promoCodeResult: ICheckPromoCodeResult) {
        AxessViewer.loadPartialView('/GiftCards/ApplyGiftCardEMoney', {
            giftCard,
        }, (result: any) => {
            if (result.success) {
                localStorage.setItem('reloadFlag', 'true');
                location.reload();
            } else if (promoCodeResult.discountFound === false) {
                //<label class="field-error ax-pt-xs">Reset</label>
                const errorLabel = $('<label></label>').addClass('field-error ax-pt-xs').attr('data-promocode', "result").html(promoCodeResult.errorMessage);
                $('[name=PromoCodPop] + label').after(errorLabel);

                setTimeout(() => {
                    $('[data-promocode="result"]').remove();
                }, 2500);
            }
        });
    }

}

interface ICheckPromoCodeResult {
    success: boolean;
    discountFound: false;
    promocodes: string[];
    isPromocodeApplied: boolean;
    errorMessage: string;
}